import * as React from "react";

const SSOIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#000"
      d="M12.4 14.918a.625.625 0 1 0 .884.884l3.69-3.79-3.69-3.789a.625.625 0 1 0-.883.884l2.26 2.261H2.625a.625.625 0 0 0 0 1.25H14.7zM20.75 2H9.504c-.69 0-1.25.56-1.25 1.25v5.625h1.258V4.012c0-.417.339-.756.756-.756h9.698c.418 0 .756.339.756.756l.02 15.982a.756.756 0 0 1-.756.757h-9.718a.756.756 0 0 1-.756-.757v-4.89l-1.258.002v5.644c0 .69.56 1.25 1.25 1.25H20.75c.69 0 1.25-.56 1.25-1.25V3.25C22 2.56 21.44 2 20.75 2"
    ></path>
  </svg>
);

export default SSOIcon;
